export enum EmployeeStatus {
  ACTIVE = 'active',
  UNAVAILABLE = 'unavailable',
  INVITED = 'invited',
  ARCHIVED = 'archived',
}
